import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CurrencyFormatPipe } from './pipes/currencyFormat.pipe';
import { CardProdutoComponentModule } from './components/produto/card-produto.module';
import { CardProdutoComponent } from './components/produto/card-produto';
import { ItemValuePipe } from './pipes/item-value.pipe';
import { OrderItemResponseValuePipe } from './pipes/order-item-response-value.pipe';
import { AddressFormatPipe } from './pipes/addressFormat.pipe';
import { InputDatetimeModule } from './components/v2/input-datetime/input-datetime.module';


@NgModule({
  declarations: [
    CurrencyFormatPipe,
    ItemValuePipe,
    OrderItemResponseValuePipe,
    AddressFormatPipe,
  ],
  imports: [
    CommonModule,
    CardProdutoComponentModule,
    InputDatetimeModule
  ],
  exports: [
    CurrencyFormatPipe,
    CardProdutoComponent,
    ItemValuePipe,
    OrderItemResponseValuePipe,
    AddressFormatPipe,
    InputDatetimeModule
  ]
})
export class SharedModule { }
